import { Injectable } from '@angular/core';
import { UAParser } from 'ua-parser-js';
import { environment } from '../environments/environment';
import { LayoutService } from './@core/utils';
import { AuthService } from './common/service/auth.service';
import { Accounts } from './common/util/accounts';
import { Strings } from './common/util/Strings';

@Injectable()
export class AppInitService {
	constructor(private authService: AuthService,
		private layoutService: LayoutService) { }

	init() {
		return new Promise<void>((resolve, reject) => {
			if (environment.production) {
				let baseUrl = `${window.location.protocol}//${window.location.host}`;
				environment.url.base = baseUrl;
				console.debug('Production mode');
			} else {
				environment.config.debugMode = true;
				console.log('Develop mode');
			}

			if (Accounts.isLoggedIn()) return resolve();

			// if (this.isConsole()) {
				// const url = new URL(window.location.href);
				// const ticket = this.getParameterByName('t');
				// console.info("TICKET: ", ticket);

				// if (!Strings.isBlank(ticket)) {
				// 	this.authService.loginTicket(ticket).subscribe(res => {
				// 		console.info("LOGIN TICKET: ", res);
				// 		if (res && res.result && Accounts.isLoggedIn()) {
				// 			this.layoutService.useHeader = false;
				// 			return resolve();
				// 		}
				// 	});
				// }
			// }

			console.debug("APP INIT!!!");
			this.layoutService.useHeader = true;
			resolve();
		});
	}

	private isConsole(): boolean {
		const ftsConsoleDevices = [[/(imonfts)/i], [UAParser.DEVICE.VENDOR, [UAParser.DEVICE.TYPE, UAParser.DEVICE.CONSOLE]]];
		const ua = new UAParser({ device: ftsConsoleDevices });
		return ua.getDevice() && ua.getDevice().type === UAParser.DEVICE.CONSOLE;
	}

	private getParameterByName(name) {
		const url = window.location.href;
		name = name.replace(/[\[\]]/g, '\\$&');
		const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}
}
